import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { loginGuard } from './core/guards/login.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () =>
      import('./layouts/auth-layout/auth-layout.component').then(
        (m) => m.AuthLayoutComponent
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/auth/login/login.component').then(
            (m) => m.LoginComponent
          ),
      },
    ],
  },
  {
    path: '',
    loadComponent: () =>
      import('./layouts/admin-layout/admin-layout.component').then(
        (m) => m.AdminLayoutComponent
      ),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        canActivate: [authGuard],
        data: { menu: 'dashboard_menu' },
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
      },
      {
        path: 'HR',
        canActivate: [authGuard],
        data: { menu: 'human_resource_menu' },
        loadChildren: () =>
          import('./features/hr/hr.routes').then((m) => m.hrRoutes),
      },
      {
        path: 'payroll',
        canActivate: [authGuard],
        data: { menu: 'human_resource_menu' },
        loadChildren: () =>
          import('./features/payroll/payroll.routes').then((m) => m.payrollRoutes),
      },
      {
        path: 'asset-management',
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        data: { menu: 'asset_management_menu' },
        loadChildren: () =>
          import('./features/asset-management/asset-management.routes').then((m) => m.assetManagementRoutes),
      },
      {
        path: 'learning-management',
        canActivate: [authGuard],
        data: { menu: 'learning_management' },
        loadChildren: () =>
          import('./features/learning-management/learning-management.routes').then(
            (m) => m.learningManagementRoutes
          ),
      },
      {
        path: 'task-management',
        canActivate: [authGuard],
        data: { menu: 'task_management_menu' },
        loadChildren: () =>
          import('./features/task-management/task-management.routes').then(
            (m) => m.taskManagementRoutes
          ),
      },
      {
        path: 'document-control',
        canActivate: [authGuard],
        data: { menu: 'document_control_menu' },
        loadChildren: () =>
          import('./features/document-control/document-control.routes').then(
            (m) => m.documentControlRoutes
          ),
      },
      {
        path: 'business',
        canActivate: [authGuard],
        data: { menu: 'business_menu' },
        loadChildren: () =>
          import('./features/business/business.routes').then(
            (m) => m.businessRoutes
          ),
      },
      {
        path: 'stores',
        canActivate: [authGuard],
        data: { menu: 'business_location_menu' },
        loadChildren: () =>
          import('./features/franchise/franchise.routes').then(
            (m) => m.franchiseRoutes
          ),
      },
      {
        path: 'subscriptions',
        canActivate: [authGuard],
        data: { menu: 'subscription_menu' },
        loadChildren: () =>
          import('./features/subscriptions/subscriptions.routes').then(
            (m) => m.subscriptionsRoutes
          ),
      },
      {
        path: 'discount',
        canActivate: [authGuard],
        data: { menu: 'discount_menu' },
        loadChildren: () =>
          import('./features/discount/discount.routes').then(
            (m) => m.discountRoutes
          ),
      },
      {
        path: 'authenticator',
        canActivate: [authGuard],
        data: { menu: 'authenticator_menu' },
        loadChildren: () =>
          import('./features/authenticator/authenticator.routes').then(
            (m) => m.authenticatorRoutes
          ),
      },
      {
        path: 'sales-goals',
        canActivate: [authGuard],
        data: { menu: 'sale_goals_menu' },
        loadChildren: () =>
          import('./features/sale-goal/sale-goal.routes').then(
            (m) => m.saleGoalRoutes
          ),
      },
      {
        path: 'commission',
        canActivate: [authGuard],
        data: { menu: 'comission_menu' },
        loadChildren: () =>
          import('./features/commission/commission.routes').then(
            (m) => m.commissionRoutes
          ),
      },
      {
        path: 'franchisor-region',
        canActivate: [authGuard],
        data: { menu: 'region_menu' },
        loadChildren: () =>
          import('./features/franchise/region/region.routes').then(
            (m) => m.regionRoutes
          ),
      },
    ],
  },
];
